import firebaseConfig from './firebase/config'
import networkingConfig from './networking/config'

const config = {
    firebaseConfig,
    networkingConfig
}

export function getConfig () {
    if (process.env.NODE_ENV === 'development') {
        config.firebaseConfig = firebaseConfig.development
        config.networkingConfig = networkingConfig.development
    } else if (process.env.NODE_ENV === 'staging') {
        config.firebaseConfig = firebaseConfig.staging
        config.networkingConfig = networkingConfig.staging
    } else {
        config.firebaseConfig = firebaseConfig.production
        config.networkingConfig = networkingConfig.production
    }
    return config
}



// WEBPACK FOOTER //
// ./src/config/config.js